export function getOperarioMenu() {
  const canModuleDocuments = localStorage.getItem('canModuleDocuments') === 'true'
  const canModuleVacation = localStorage.getItem('canModuleVacation') === 'true'
  const canModuleCalendarPrivacy = localStorage.getItem('canModuleCalendarPrivacy') === 'true'
  const menu = [
    {
      title: 'Fichar',
      route: 'journeyDay',
      icon: 'LogInIcon',
    },
    {
      title: 'Parte de horas',
      route: 'partes',
      icon: 'ClockIcon',
    },
    ...(canModuleDocuments ? [{
      title: 'Documentos',
      route: 'documents',
      icon: 'FileTextIcon',
    }] : []),
    ...(canModuleVacation ? [{
      title: 'Solicitudes',
      route: 'vacations',
      icon: 'CalendarIcon',
    }] : []),
    ...(canModuleVacation && canModuleCalendarPrivacy ? [{
      title: 'Calendario',
      route: 'vacations-calendar-admin',
      icon: 'CalendarIcon',
    }] : []),
    {
      title: 'Política de registro horario',
      route: 'viewPolicy',
    },
  ]
  return menu
}
